import * as z from "zod/v4";

/**
 * Discriminated union of every observable outcome of starting Recover phone
 * number provisioning. Each branch maps to a distinct UI state on the
 * `rec-phone-number` step or a distinct ops alert.
 *
 *  - `started` — workflow successfully kicked off; merchant should see
 *    "pending" status on `rec-phone-number`
 *  - `already-running` — a workflow is already in flight for this team;
 *    typically the merchant clicked Continue twice or refreshed mid-flow
 *  - `completed` — a Verified PhoneNumber record already exists; nothing
 *    to do
 *  - `blocked` — provisioning could not start; the `reason` field
 *    identifies why so the UI can prompt for the gap or escalate to ops
 */
export const provisionRecoverPhoneNumber = {
  name: "provisionRecoverPhoneNumber" as const,
  input: z.object({}),
  output: z.discriminatedUnion("status", [
    z.object({ status: z.literal("started"), workflowId: z.string() }),
    z.object({ status: z.literal("already-running"), workflowId: z.string() }),
    z.object({ status: z.literal("completed"), phoneNumber: z.string() }),
    z.object({
      status: z.literal("blocked"),
      reason: z.enum([
        "missing-form-data",
        "missing-merchant-data",
        "bandwidth-unavailable",
        "internal-error",
      ]),
      detail: z.string().optional(),
      missingFields: z.array(z.string()).optional(),
    }),
  ]),
};
